export default function LogoIcon({ width, height }: { width?: number; height?: number }) {
  return (
    <svg
      width={width ?? '36'}
      height={height ?? '33'}
      viewBox="0 0 36 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M17.8381 5.633L17.8381 30.0634"
        stroke="#FF644E"
        stroke-width="5"
        stroke-linecap="round"
      />
      <path
        d="M9.87775 2.99988L9.87776 22.8683"
        stroke="#FF644E"
        stroke-width="5"
        stroke-linecap="round"
      />
      <path d="M2.5 7.8537L2.5 16.0667" stroke="#FF644E" stroke-width="5" stroke-linecap="round" />
      <path
        d="M26.1222 2.99988L26.1222 22.8683"
        stroke="#FF644E"
        stroke-width="5"
        stroke-linecap="round"
      />
      <path
        d="M33.5 7.8537L33.5 16.0667"
        stroke="#FF644E"
        stroke-width="5"
        stroke-linecap="round"
      />
    </svg>
  );
}
